import { removeNamespace } from '@/utils/helpers'

export const QUIZ_TYPES = {
  getters: {
    selected: 'quiz/selected'
  },
  mutations: {
    SET_QUIZ: 'quiz/SET_QUIZ',
    SET_QUIZ_PROGRESS: 'quiz/SET_QUIZ_PROGRESS',
    SET_SELECTION: 'quiz/SET_SELECTION',
    SET_ACTIVE_QUESTION: 'quiz/SET_ACTIVE_QUESTION',
    SET_RESULT: 'quiz/SET_RESULT'
  },
  actions: {
    resetQuiz: 'quiz/resetQuiz',
    getResult: 'quiz/getResult'
  }
}

export const QuizProgress = Object.freeze({
  NotStarted: 0,
  Active: 1,
  Completed: 2
})

const _types = removeNamespace('quiz', QUIZ_TYPES)

const resetSelections = (state) => {
  state.quiz.questions.forEach((q, i) => {
    state.selections[i] = null
  })
}

const createResultMask = (arr) => {
  if (!arr || !arr.length) {
    return '[]'
  }
  return '[' + arr.join() + ']'
}

const maskContainsWildCard = (maskStr) => {
  if (!maskStr || maskStr === '') {
    return false
  }
  return new RegExp(/[*]+/g).test(maskStr)
}

const maskToArr = (maskStr) => {
  if (!maskStr || maskStr === '') {
    return []
  }
  return maskStr.replace('[', '').replace(']', '').split(',')
}

const state = () => ({
  quiz: null,
  quizProgress: QuizProgress.NotStarted,
  activeQuestion: 0,
  selections: [],
  result: null
})

const getters = {
  [_types.getters.selected] (state) {
    return state.selections[state.activeQuestion]
  }
}

const mutations = {
  [_types.mutations.SET_QUIZ] (state, quiz) {
    state.quiz = quiz
    resetSelections(state)
  },
  [_types.mutations.SET_QUIZ_PROGRESS] (state, progress) {
    state.quizProgress = progress
  },
  [_types.mutations.SET_SELECTION] (state, selection) {
    state.selections.splice(state.activeQuestion, 1, selection)
  },
  [_types.mutations.SET_ACTIVE_QUESTION] (state, index) {
    state.activeQuestion = index
  },
  [_types.mutations.SET_RESULT] (state, result) {
    state.result = result
  }
}

const actions = {
  [_types.actions.resetQuiz] ({ state }) {
    state.quizProgress = QuizProgress.NotStarted
    state.activeQuestion = 0
    resetSelections(state)
    state.score = 0
  },
  [_types.actions.getResult] ({ state, commit }) {
    let matchedMask
    const selectionMask = createResultMask(state.selections)
    let resultMasks = state.quiz.results.map(r => r.fields.mask.replace(/\s/g, ''))
    // sort masks by * count asc
    resultMasks = resultMasks
      .map(mask => {
        let wildCardCount = 0
        maskToArr(mask).forEach(m => {
          if (m === '*') {
            wildCardCount++
          }
        })
        return {
          count: wildCardCount,
          mask: mask
        }
      })
      .sort((a, b) => a.count - b.count)
      .map(m => m.mask)
    // attempt to match selectionMask to result masks
    for (let i = 0; i < resultMasks.length; i++) {
      let maskToMatch = resultMasks[i]
      const maskWildCard = maskContainsWildCard(resultMasks[i])
      if (maskWildCard) {
        // if mask has * wildcard, fill * with our own selections
        let correctSelections = maskToArr(resultMasks[i])
        correctSelections = correctSelections.map((o, j) => {
          if (o === '*') {
            return state.selections[j]
          }
          return o
        })
        maskToMatch = createResultMask(correctSelections)
      }
      if (selectionMask === maskToMatch) {
        matchedMask = resultMasks[i]
        break
      }
    }
    if (matchedMask) {
      const matched = state.quiz.results.find(r => r.fields.mask === matchedMask)
      commit(_types.mutations.SET_RESULT, matched)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
